<template>
	<div class="container mx-auto max-w-5xl px-4">
		<div class="flex flex-col justify-between">
			<div class="xs:p-2 flex overflow-hidden p-0">
				<HelpfulTips>
					<template v-if="isDamagedQuiz">
						Check what's true about your car from the list. For example, if your car
						does not drive, check “Vehicle is inoperable”.
					</template>
					<template v-else>
						Verify the following are true for your car. If something doesn't apply, just
						uncheck the box. For example, if your car was once a rental, go ahead and
						uncheck “No Prior Rental, Taxi, or Fleet Usage”.
					</template>
				</HelpfulTips>

				<div class="grow basis-1/2 overflow-y-auto px-4">
					<div
						v-for="quiz in form.quizList"
						:key="quiz.id"
						class="mb-4 box-border flex cursor-pointer flex-col"
						@click="toggleQuiz(quiz)"
					>
						<div class="flex">
							<div class="xs:mr-6 mr-3">
								<AppCheckbox
									class="text-success-base mt-1"
									:class="{
										'text-warning': isDamagedQuiz,
									}"
									:checked="form.quizItems.some(qs => qs.id === quiz.id)"
								/>
							</div>

							<div class="flex flex-col">
								<div class="flex items-center justify-between">
									<div
										class="text-main-400 flex grow justify-between text-base font-bold lg:text-xl"
									>
										<p>{{ quiz.name }}</p>
										<div class="flex"></div>
									</div>
								</div>

								<div class="text-15 xs:text-base lg:text-xl">
									{{ quiz.description }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { QuizItem, RateCondition, useFormStore } from '../../../stores/form'
	import { computed } from 'vue'
	import HelpfulTips from '../components/HelpfulTips.vue'
	import AppCheckbox from '../../common/AppCheckbox.vue'

	const form = useFormStore()

	const isDamagedQuiz = computed(() => form.rateCondition === RateCondition.Damaged)

	const toggleQuiz = (quiz: QuizItem): void => {
		const index = form.quizItems.findIndex(qs => qs.id === quiz.id)
		if (~index) {
			form.quizItems.splice(index, 1)
		} else {
			form.quizItems.push(quiz)
		}
	}
</script>
